<script>
import moment from 'moment'
import { mapActions } from 'vuex'
export default {
  props: ['siteView'],
  data() {
    return {
      date: moment().format('DD-MM-YYYY'),
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      loading: false,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      resources: []
    }
  },
  computed: {
    siteLocation() {
      if (this.siteView.geolocation) {
        const [lat, lng] = this.siteView.geolocation.split(',')
        return {
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        }
      }

      return undefined
    }
  },
  mounted() {
    this.onFetchData()
  },
  methods: {
    ...mapActions('projectMgt/siteProfile', ['viewCheckInOut']),
    onFetchData() {
      this.loading = true
      this.viewCheckInOut({
        id: this.siteView.id,
        params: { date: this.date }
      })
        .then(response => {
          this.resources = response.data
          if (this.siteLocation !== undefined) {
            this.center = this.siteLocation
          } else if (this.resources.length) {
            const { lat, lng } = this.resources[0]
            this.center.lat = lat
            this.center.lng = lng
          }
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => (this.loading = false))
    }
  }
}
</script>

<template>
  <div>
    <h4>{{ siteView.site_name }}</h4>
    <a-date-picker
      class="ts-w-full"
      v-model="date"
      format="DD-MM-YYYY"
      valueFormat="DD-MM-YYYY"
      @change="onFetchData"
    />

    <!-- {{ siteView.geolocation }}' -->

    <div class="ts-mt-3">
      <gmap-map :center="center" :zoom="13" style="width:100%;  height: 80vh;">
        <gmap-info-window
          v-for="(r, index) in resources"
          :key="index"
          :options="infoOptions"
          :position="{
            lat: r.lat,
            lng: r.lng
          }"
          :opened="true"
        >
          <p class="ts-mb-0 ts-text-blue-500">{{ r.name }}</p>
          <p class="ts-mb-0">
            <small>{{ r.check_in_date }}</small>
          </p>
        </gmap-info-window>
        <gmap-info-window
          v-if="siteLocation !== undefined"
          :options="infoOptions"
          :position="siteLocation"
          :opened="true"
        >
          <p class="ts-mb-0 ts-text-blue-500">{{ siteView.site_name }}</p>
        </gmap-info-window>
      </gmap-map>
    </div>
    {{ siteLocation }}
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<style>
.gm-ui-hover-effect {
  opacity: 0.6;
  display: none !important;
}
</style>
